import React from "react";
import Title from "../../title/title";
import { mapForumDatum } from "../../../constants/map/forum";
import ReactTable from "../../reactTable";
import { formattedDate, invalidDate } from "../../../constants/misc";
import Folder from "../../svgs/icoMoon/icons/folder/folder";
import { Link } from "react-router-dom";
import ForumSubscribeButton from "./ForumSubscribeButton";

const ForumTable = ({
  title,
  description,
  forumList,
  subscriptions,
  isLoggedIn,
}) => {
  const tableData = React.useMemo(
    () => forumList.map((f) => mapForumDatum(f)),
    [forumList]
  );
  const columns = React.useMemo(() => [
    {
      header: "FORUM",
      accessorKey: "name",
      cell: ({ row }) => {
        const { name, uuid } = row.original;
        return (
          <>
            <Link to={"/forum/" + uuid}>
              <Folder />
              {" " + name}
            </Link>
            {isLoggedIn && (
              <ForumSubscribeButton
                uuid={uuid}
                subscribed={subscriptions[uuid]?.subscribed}
              />
            )}
          </>
        );
      },
    },
    {
      header: "TOPICS",
      accessorKey: "statistics.topic_count",
    },
    {
      header: "POSTS",
      accessorKey: "statistics.comment_count",
    },
    {
      header: "LAST POSTS",
      accessorKey: "last_post",
      cell: ({ getValue }) => {
        const value = getValue();
        return value && value.created.getTime() !== invalidDate.getTime() ? (
          <span>
            {formattedDate(value.created)} from <span>{value.name}</span>
          </span>
        ) : (
          "n/a"
        );
      },
    },
  ]);

  return (
    <div className="nbg_table" style={{ marginTop: "3rem" }}>
      <Title type="array">{title}</Title>
      <div
        className="array_descr"
        dangerouslySetInnerHTML={{
          __html: description
            ? description.replace(/<\/?[^>]+(>|$)/g, "")
            : null,
        }}
      />

      <ReactTable
        headerColumnClass={"table-header-column"}
        data={tableData}
        columns={columns}
        filter={false}
        pagination={false}
      />

      <div className="row tFooter" style={{ height: "50px" }} />
    </div>
  );
};

export default ForumTable;
